<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" width="30%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" size="mini" class="code-type-dialog-form">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="1" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="材料名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="materialName" style="margin-bottom: 0;">
                        <el-input v-show="isShow" v-model="dataForm.id" placeholder="包装运输费表ID" readonly></el-input>
                        <el-input v-show="isShow" v-model="dataForm.boxTriansportId" placeholder="boxTriansportId" readonly></el-input>
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.materialName" maxlength="100"></el-input>
                        <span v-else>{{dataForm.materialName}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="使用量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="userdNum" style="margin-bottom: 0;">
                        <ctl-number v-if="viewFlag !== 'view'" v-model="dataForm.userdNum" :min="0" :max="1000000000"></ctl-number>
                        <span v-else>{{dataForm.userdNum}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="单价" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="unitPrice" style="margin-bottom: 0;">
                        <ctl-number v-if="viewFlag !== 'view'" :precision="3" v-model="dataForm.unitPrice" :min="0" :max="1000000000"></ctl-number>
                        <span v-else>{{dataForm.unitPrice}}</span>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="view.visible = false">
            <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
        </el-button>
        <el-button size="mini" type="primary" v-if="viewFlag != 'view'" plain @click="dataFormSubmit()">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    boxDetailById,
    boxDetailInsert,
    boxDetailUpdate,
    getRfqBaseById
} from "@/controller/quotation";
import {
    mapping
} from "@/utils"
import CtlNumber from '@/views/common/ctl-number'
export default {
    components: {
        CtlNumber
    },
    data() {
        return {
            isShow: false,
            viewFlag: '',
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewData: {},
            dataForm: {
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                roundNo: '',
                materialName: '',
                userdNum: 0,
                unitPrice: 0
            },
            // 开始
            dataRule: {
                // name: [
                //     {
                //         required: true,
                //         message: "编码名称不能为空",
                //         trigger: "blur",
                //     },
                // ],
                // type: [
                //     {
                //         required: true,
                //         message: "编码类型不能为空",
                //         trigger: "blur",
                //     },
                // ],
            },
        };
    },
    methods: {
        // 初始化
        init(id, boxTriansportId, viewFlag, data, rfqId) {
            this.view.visible = true;
            this.viewFlag = viewFlag
            mapping(data, this.dataForm)
            console.log('rfqId????????????????',this.dataForm.rfqId)
            this.$nextTick(() => {
                // this.$refs["dataForm"]={};
                this.dataForm['boxTriansportId'] = boxTriansportId;
                this.$refs['dataForm'].resetFields()
                if (id) {
                    // 根据id查
                    boxDetailById({}, id).then((data) => {
                        if (data && data.code === "00" && data.body) {
                            this.dataForm = data.body;
                            this.id = ''
                            this.dataForm.rfqId = rfqId
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    getRfqBaseById({}, this.dataForm.rfqId).then(data => {
                        if (data && data.code === '00') {
                            if("2" != data.body.rfqStatus) {
                                this.$message.warning("询价单不是询价中状态，不允许修改报价相关信息")
                            } else {
                                if (this.dataForm.id) {
                                    // 更新表
                                    boxDetailUpdate(this.dataForm)
                                        .then((data) => {
                                            if (data && data.code === "00") {
                                                this.$message({
                                                    message: "操作成功",
                                                    type: "success",
                                                    duration: 1500,
                                                    onClose: () => {
                                                        this.view.visible = false;
                                                        this.$emit(
                                                            "refreshBoxDataList"
                                                        );
                                                        this.$emit(
                                                            "loadFormDataAll"
                                                        );
                                                    },
                                                });
                                            } else {
                                                this.$message.error(data.msg);
                                            }
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                } else {
                                    // 创建表
                                    boxDetailInsert(this.dataForm)
                                        .then((data) => {
                                            if (data && data.code === "00") {
                                                this.$message({
                                                    message: "操作成功",
                                                    type: "success",
                                                    duration: 1500,
                                                    onClose: () => {
                                                        this.view.visible = false;
                                                        this.$emit(
                                                            "refreshBoxDataList"
                                                        );
                                                        this.$emit(
                                                            "loadFormDataAll"
                                                        );
                                                    },
                                                });
                                            } else {
                                                this.$message.error(data.msg);
                                            }
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                }
                            }
                        }
                    })
                }
            });
        },
        getStyle() {
            return 'width: 100px; text-align: right'
        },
        getStyle2() {
            // return 'width: 647.5px;'
        }
    },
};
</script>

<style lang="scss">
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
